import React from 'react';
import { useAttributeFormBuilder } from '../../../../Hooks/Display/useComponentProperties';
import { useTranslation } from 'react-i18next';
import CreateSection from "../Sections/CreateSection"

const CreateStep = () => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [{ steps }, dispatch] = useAttributeFormBuilder();
    const handleAddStep = () => {
        dispatch.addStep();
    }

    return (
        <div>
            <button className='btn btn-sm btn-secondary mt-2 font-weight-bold' onClick={handleAddStep}>
                <i className='fa fa-plus'></i> {t("step.add_step", { ns: "display/components/form" })}
            </button>
            <CreateSection />
        </div>
    );
}

export default CreateStep;